import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import useColorFilterSelection from "./UseColorFilterSelection";
import { removeFiltersPayload } from "@redux/slices/searchFilters";

const useRemoveColorFilters = (sectionName: any) => {
  const dispatch = useDispatch();
  const {
    isWhiteColorsSelected,
    isFancyColorsSelected,
    isOvertonesSelected,
    isIntensitiesSelected,
    isArgyleSelected,
  } = useColorFilterSelection(sectionName);

  const whiteSelected = isWhiteColorsSelected();
  const fancySelected =
    isFancyColorsSelected() || isIntensitiesSelected() || isOvertonesSelected();
  const argyleSelected = isArgyleSelected();

  const prevSelection = useRef({
    whiteSelected,
    fancySelected,
    argyleSelected,
  });

  useEffect(() => {
    const prev = prevSelection.current;

    if (fancySelected && (prev.whiteSelected || prev.argyleSelected)) {
      dispatch(
        removeFiltersPayload({
          sectionName,
          payloadName: ["color_from", "color_to", "argyle"],
        })
      );
    } else if (argyleSelected && (prev.whiteSelected || prev.fancySelected)) {
      dispatch(
        removeFiltersPayload({
          sectionName,
          payloadName: ["color_from", "color_to", "fancy_colors"],
        })
      );
    } else if (whiteSelected && (prev.fancySelected || prev.argyleSelected)) {
      dispatch(
        removeFiltersPayload({
          sectionName,
          payloadName: ["fancy_colors", "argyle"],
        })
      );
    }

    prevSelection.current = { whiteSelected, fancySelected, argyleSelected };
  }, [whiteSelected, fancySelected, argyleSelected, dispatch, sectionName]);
};

export default useRemoveColorFilters;
